import { render, staticRenderFns } from "./queuelist.vue?vue&type=template&id=3f06c0ea&scoped=true&"
import script from "./queuelist.vue?vue&type=script&lang=js&"
export * from "./queuelist.vue?vue&type=script&lang=js&"
import style0 from "./queuelist.vue?vue&type=style&index=0&id=3f06c0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f06c0ea",
  null
  
)

export default component.exports